<template>
  <div class="personalDetails">
    <div class="content">
      <div class="headerBanner">
        <div @click="closeDetails">
          <b-icon class="closeIcon" pack="far" icon="times-circle"></b-icon>
        </div>
        <h2 class="title is-size-4">Gebruiker aanpassen</h2>
      </div>
      <br />
      <div class="textArea">
        <b-field>
          <div class="label">Activeer/Deactiveer</div>
          <div class="switchbutton">
            <b-switch
              :value="user.isEnabled"
              @input="enableDisable"
            >{{ user.isEnabled | formatBool }}</b-switch>
          </div>
        </b-field>
        <br />
        <b-field horizontal label="Voornaam">
          <b-input is-inverted v-model="firstname" expanded></b-input>
        </b-field>
        <b-field horizontal label="Achternaam">
          <b-input v-model="lastname" expanded></b-input>
        </b-field>
        <b-field horizontal label="Email">
          <b-input name="email" type="email" v-model="email" expanded></b-input>
        </b-field>

        <b-field horizontal label="Organisatie">
          <b-select v-if="orga != null" :value="orga" placeholder="Kies Organisatie...">
            <option
              v-for="option in organisationList"
              :value="option.id"
              :key="option.id"
            >{{ option.orga }}</option>
          </b-select>
        </b-field>
        <br />
        <div class="buttons2">
          <div class="field has-addons">
            <p class="control">
              <a class="button" @click="refresh">
                <div class="svg-icon svg-baseline pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                  >
                    <path
                      d="M43.3 28.2v.1q-1.6 7-7 11.4Q31 44 24 44q-3.8 0-7.4-1.4-3.5-1.5-6.3-4.1l-3.4 3.3q-.5.5-1.1.5-.7 0-1.2-.5T4 40.7V29q0-.7.5-1.2t1.2-.5h11.6q.7 0 1.2.5T19 29q0 .7-.5 1.2L15 33.7q1.9 1.8 4.2 2.7 2.4 1 4.9 1 3.5 0 6.5-1.8 3-1.7 4.9-4.6l1.3-3q.2-.7.8-.7h5q.4 0 .6.3.2.2.2.6zM44 7.3V19q0 .7-.5 1.2t-1.2.5H30.7q-.7 0-1.2-.5T29 19q0-.7.5-1.2l3.6-3.6q-3.9-3.5-9.1-3.5-3.5 0-6.5 1.7T12.6 17l-1.3 3q-.2.7-.8.7H5.3q-.3 0-.6-.3-.2-.2-.2-.6v-.1q1.7-7 7-11.4Q16.8 4 24 4q3.8 0 7.4 1.4Q35 7 37.8 9.5l3.4-3.3q.5-.5 1.1-.5.7 0 1.2.5t.5 1.1z"
                    />
                  </svg>
                </div>
                <span>Reset</span>
              </a>
            </p>

            <p class="control">
              <a class="button is-success" @click="saveChanges()">
                <span class="icon is-small">
                  <i class="fas fa-check"></i>
                </span>
                <span>Wijzig</span>
              </a>
            </p>
          </div>
        </div>
        <h1 class="title is-6">Toegewezen Projecten</h1>

        <div class="assigned-projects-container">
          <claim-container
            name="Leesrechten"
            level="Read"
            :claims="filtered('Read')"
            @dragged="itemDragged"
          ></claim-container>
          <claim-container
            name="Bewerkrechten"
            level="Write"
            :claims="filtered('Write')"
            @dragged="itemDragged"
          ></claim-container>
          <claim-container
            name="Beheerdersrechten"
            level="Admin"
            :claims="filtered('Admin')"
            @dragged="itemDragged"
          ></claim-container>
          <claim-container
            name="Geen rechten"
            level="noAccess"
            :claims="filteredLeftProjects"
            @dragged="itemDragged"
            class="noaccess"
            :noaccess="true"
            v-model="search"
          ></claim-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClaimItem from './ClaimItem'
import ClaimContainer from './ClaimContainer'
import { mapGetters } from 'vuex'
import UserService from '@/services/userService'
import Mixin from '@/mixins/mixin.js'

export default {
  components: {
    ClaimItem,
    ClaimContainer
  },
  filters: {
    formatBool: function(value) {
      return value ? 'Actief' : 'Niet actief'
    }
  },
  mixins: [Mixin],
  props: {
    claimType: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      defaultOrga: 'Atlas Techrin International',
      organisationList: [
        { id: 1, orga: 'Atlas Techrin International' },
        { id: 2, orga: 'Other' }
      ],
      firstname: this.user.firstName,
      lastname: this.user.lastName,
      email: this.user.email,
      orga: this.user.organisation,
      search: ''
    }
  },
  computed: {
    ...mapGetters(['claimsForSelectedUser', 'leftProjectsForSelectedUser']),
    sortedProjectClaims: function() {
      const sorted = this.claimsForSelectedUser
      const filteredProjects = sorted.filter(c => c.scope == 'Project')
      return filteredProjects.sort((a, b) => a.identifier - b.identifier)
    },
    sortedOrganisationClaims: function() {
      const sorted = this.claimsForSelectedUser
      const filteredOrganisationClaims = sorted.filter(c => c.scope == 'Organization')
      return filteredOrganisationClaims.sort((a, b) => a.identifier - b.identifier)
    },
    leftProjects: function() {
      return this.leftProjectsForSelectedUser
    },
    filteredLeftProjects: function() {
      if (this.search == '' || !this.search || !this.leftProjects) {
        return this.leftProjects
      }
      const st = this.search.toLowerCase()
      return this.leftProjects.filter(
        a =>
          a.city.toLowerCase().includes(st) || a.address.toLowerCase().includes(st) || a.name.toLowerCase().includes(st)
      )
    }
  },
  watch: {
    user: function(value) {
      console.log(`%cUser ${this.user.email} has changed or initialized`, 'color: yellow')
      this.lastname = this.user.lastName
      this.firstname = this.user.firstName
      this.email = this.user.email
      if (this.user.organizations[0] != null) {
        this.orga = this.user.organizations[0].identifier
      } else {
        this.orga = 2
      }
    }
  },
  methods: {
    refresh() {
      this.lastname = this.user.lastName
      this.firstname = this.user.firstName
      this.email = this.user.email
      this.orga = this.user.orga
    },
    async enableDisable(e) {
      if (this.user.isEnabled == e) {
        console.log(`%cSelected user is enabled was already ${e}. Skipping changes`, 'color: yellow')
        return
      }
      if (this.user.isEnabled) {
        const res = await UserService.disableUser(this.$store.getters.selectedUser.email)
        if (res.status == 200) {
          this.$store.commit('updateStatusForSelectedUser', false)
          console.log(`%cSelected user is disabled`, 'color: yellow')
        }
      } else {
        const res = await UserService.enableUser(this.$store.getters.selectedUser.email)
        if (res.status == 200) {
          this.$store.commit('updateStatusForSelectedUser', true)
          console.log(`%cSelected user is enabled`, 'color: yellow')
        }
      }
    },
    filtered(_filter) {
      return this.sortedProjectClaims.filter(function(item) {
        return item.level === _filter
      })
    },
    closeDetails() {
      this.$store.commit('setSelectedUser', null)
    },
    itemDragged({ targetLevel, item }) {
      const rechten = this.claimsFormEnglishToDutch(targetLevel)
      const user = this.user
      this.popup(rechten, user, item, targetLevel, false)
    },
    saveChanges() {
      const oldSelectedUser = this.$store.getters.selectedUser
      oldSelectedUser.firstName = this.firstname
      oldSelectedUser.lastName = this.lastname
      oldSelectedUser.email = this.email
    }
  }
}
</script>

<style lang="scss">
@import '../../sass/main.scss';
$fw600: bold;

$opacity: 0.2;
.assigned-projects-container.notification2:first-child {
  margin: -10px 0 0 0;
}
// .noaccess {
//   .tag:not(body).is-primary {
//     background-color: rgba($fsdyellow, 0.3); //lighten($gray, 5%);
//     color: rgba(black, 0.5);
//   }
// }
.noaccess {
  .tag {
    background-color: rgba($fsdyellow, 0.5) !important; //lighten($gray, 5%);
    color: rgba(black, 0.5);
  }
  overflow-x: hidden;
  overflow-y: auto;
  .input {
    background-color: rgba(gray, $opacity); //$gray;
    color: $off-white;
    border-color: $off-white;
    box-shadow: 0 0 1.5px 1px rgba($off-white, 0.25);
    width: 100%;
  }
  .control {
    width: 40%;
    display: inline-block;
    height: 30px;
    z-index: 1;
    margin-left: 50px;
    margin-top: -4px;
    margin-bottom: 2px;
    color: $off-white;
  }
  .firstPart {
    width: 100px;
    display: inline-block;
    vertical-align: top;
  }
  .label {
    color: $off-white;
  }
}
.notification2 {
  padding: 8px;
  margin: 10px 0px 10px 0;
  background-color: rgba(gray, $opacity); //$gray-blue;
  border: 1px solid $off-white; //$fsdyellow;
  border-radius: 4px;
  max-height: 410px;
  color: $off-white;
  box-shadow: 0 0 1.5px 1px rgba($off-white, 0.25);
  p {
    font-size: 12px;
    font-weight: $fw600;
    margin: -6px 0px 2px 4px;
    color: $off-white;
  }
  .stickyTitle {
    position: sticky;
    top: 0px;
  }
  .help {
    margin: 0px 0px 0px 4px;
    color: $off-white;
  }
}
.notification2:hover {
  box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
}

.notification3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .field {
    margin: 0;
    padding: 0;
    .tag {
      margin: 3px 4px;
    }
    .pill {
      transform: translate(0, 0);
      color: $green;
      &:hover {
        cursor: move;
      }
    }
    .tag:not(body).is-primary {
      background-color: $fsdyellow; //lighten($gray, 5%);
      color: black;
    }
  }
}
.closeIcon {
  float: right;
  color: $off-white;
  cursor: pointer;
}

.personalDetails {
  position: fixed;
  overflow: auto;
  .label {
    color: $off-white;
    float: left;
  }
  h1 {
    display: inline-block;
  }
  // position: absolute;
  float: right;
  top: 0;
  height: 100%;
  background-color: $gray; //lighten($gray, 5%);
  .buttons2 {
    float: right;
    display: block;
    margin-bottom: -10px;

    .field.has-addons {
      .button.is-success {
        background-color: $fsdyellow;
        color: $gray;
        box-shadow: 0 0 1.5px 1px rgba($off-white, 0.25);
      }
      .button.is-success:hover {
        box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
      }
      .button {
        background-color: $gray;
        color: $off-white;
        .svg-icon {
          color: $off-white;
          fill: $off-white;
          margin-top: -3px;
          padding-right: 6px;
        }
        box-shadow: 0 0 1.5px 1px rgba($off-white, 0.25);
      }
      .button:hover {
        box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
      }
    }
  }
  //border-radius: 7px;
  border: 1px solid #555;
  .title {
    color: $off-white;
  }
  .headerBanner {
    padding: 10px;
    padding-bottom: 17px;

    //background-color: lighten($gray, 5%);
    padding-top: 62px;

    border: 1px solid $off-white;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    .title {
      color: $off-white;
    }
  }
  .textArea {
    padding: 10px;
    padding-top: 0px;
    height: 100%;
    .input {
      background-color: rgba(gray, $opacity); //$gray;
      color: $off-white;
      border-color: $off-white;
      box-shadow: 0 0 1.5px 1px rgba($off-white, 0.25);
    }
    .input:focus {
      box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
    }
    .input:hover {
      box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
    }
    .label {
      color: $off-white;
    }
    .select select {
      background-color: rgba(gray, $opacity);
      color: $off-white;
      border-color: $off-white;
      box-shadow: 0 0 1.5px 1px rgba($off-white, 0.25);
    }
    .select::after {
      border-color: $fsdyellow;
      border-width: 2px;
    }
    .select:hover::after {
      border-color: $off-white;
    }
    .select select:focus {
      box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
    }
    .select select:hover {
      box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
    }
    .switchbutton {
      margin-left: 55px;
      .control-label {
        color: $off-white;
        font-weight: $fw600;
        font-size: 1rem;
      }
      .switch input[type='checkbox']:checked + .check {
        background-color: $fsdyellow;
      }
      .switch input[type='checkbox']:checked + .check:before {
        background-color: $gray;
      }
      .switch input[type='checkbox'] + .check {
        border-style: solid;
        background-color: rgba(gray, $opacity);
        border-width: 1px;
        border-color: $off-white;
      }
      .switch input[type='checkbox'] + .check:before {
        background-color: $fsdyellow;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/PersonalDetails.vue